import { render, staticRenderFns } from "./orders_waiting_on_customer_widget.vue?vue&type=template&id=057d5502&scoped=true&"
import script from "./orders_waiting_on_customer_widget.vue?vue&type=script&lang=js&"
export * from "./orders_waiting_on_customer_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057d5502",
  null
  
)

export default component.exports